"use client";

import React from "react";
import {
  Box,
  Typography,
  Stack,
  Link as MUILink,
  colors,
  useMediaQuery,
} from "@mui/material";
import Link from "next/link";
import { navLinks } from "@/shared/constants";
import Logo from "./Logo";

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const isMobile = useMediaQuery("(max-width:899px)");

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "primary.main",
        color: "#fff",
        px: { xs: "16px", md: "0" },
        pt: "56px",
        pb: "83px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      {/* Logo */}
      <Logo
        variant="white"
        width={isMobile ? 320 : 250}
        height={isMobile ? 60 : 50}
      />

      {/* Description */}
      <Typography
        sx={{
          mt: "20px",
          mb: "20px",
          maxWidth: "692px",
          textAlign: "center",
          fontFamily: "RethinkSans, sans-serif",
          fontSize: "16px",
          lineHeight: 1.5,
          fontWeight: 400,
          width: isMobile ? "80%" : "auto",
        }}
      >
        Nest Shipper is an all-in-one platform that helps businesses create
        shipping labels effortlessly, connect their sales channels, and access
        discounted carrier rates. It simplifies logistics, reduces costs, and
        supports seamless scaling for any size of operation.
      </Typography>

      {/* Email */}
      <MUILink
        href="mailto:info@nestshipper.com"
        underline="none"
        sx={{
          fontFamily: "Poppins, sans-serif",
          fontSize: isMobile ? "18px" : "24px",
          lineHeight: 1.33,
          color: "#fff",
          mb: "27px",
        }}
      >
        info@nestshipper.com
      </MUILink>

      {/* Social Icons */}
      {/* <Stack
        direction="row"
        spacing="16px"
        mb={{ xs: "40px", md: "56px" }}
        justifyContent="center"
        alignItems="center">
        {["linkedin", "instagram", "pinterest", "facebook", "youtube"].map(
          (name) => (
            <Link key={name} href="#" passHref>
              <Image
                src={`/images/socials/${name}.png`}
                alt={`${name} icon`}
                width={name === "youtube" ? 25.5 : 24}
                height={name === "youtube" ? 18 : 24}
                style={{ objectFit: "contain" }}
              />
            </Link>
          )
        )}
      </Stack> */}

      <Box
        sx={{
          width: { xs: "25%", md: "70%" },
          maxWidth: "auto",
          borderTop: "1px solid rgba(255, 255, 255, 0.3)",
          mb: isMobile ? "20px" : "60px",
        }}
      />
      {/* Nav Links */}
      <Stack
        direction={{ xs: "column", md: "row" }}
        spacing={{ xs: 2, md: 8 }}
        alignItems="center"
        mb={{ xs: "20px", md: "60px" }}
      >
        {navLinks.map((link) => (
          <MUILink
            key={link.label}
            component={Link}
            href={link.href}
            underline="none"
            sx={{
              fontFamily: "Poppins, sans-serif",
              fontSize: "24px",
              fontWeight: 700,
              lineHeight: 1.33,
              color: "#fff",
            }}
          >
            {link.label}
          </MUILink>
        ))}
      </Stack>

      {/* Divider */}
      <Box
        sx={{
          width: { xs: "25%", md: "70%" },
          maxWidth: "auto",
          borderTop: "1px solid rgba(255, 255, 255, 0.3)",
          mb: "40px",
        }}
      />
      {/* Bottom Row */}

      {isMobile ? (
        <Stack
          spacing={1.5}
          alignItems="center"
          textAlign="center"
          sx={{ width: "100%" }}
        >
          <MUILink
            href="/privacy-policy"
            underline="none"
            sx={{
              fontFamily: "Poppins, sans-serif",
              fontSize: "16px",
              lineHeight: 2,
              color: "#fff",
            }}
          >
            Privacy Policy
          </MUILink>
          <Stack direction="row" spacing="16px" justifyContent="center">
            <Typography
              sx={{
                fontFamily: "Poppins, sans-serif",
                fontSize: "16px",
                lineHeight: 2,
                color: "#fff",
              }}
            >
              Copyright © {currentYear}
            </Typography>
            <MUILink
              href="/terms-and-conditions"
              underline="none"
              sx={{
                fontFamily: "Poppins, sans-serif",
                fontSize: "16px",
                lineHeight: 2,
                color: "#fff",
              }}
            >
              Terms & Conditions
            </MUILink>
          </Stack>
        </Stack>
      ) : (
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          width="70%"
          maxWidth="1366px"
          spacing={0}
        >
          <Typography
            sx={{
              fontFamily: "Poppins, sans-serif",
              fontSize: "16px",
              lineHeight: 2,
              color: "#fff",
            }}
          >
            Copyright © {currentYear}
          </Typography>

          <MUILink
            href="/privacy-policy"
            underline="none"
            sx={{
              fontFamily: "Poppins, sans-serif",
              fontSize: "16px",
              lineHeight: 2,
              color: "#fff",
            }}
          >
            Privacy Policy
          </MUILink>

          <MUILink
            href="/terms-and-conditions"
            underline="none"
            sx={{
              fontFamily: "Poppins, sans-serif",
              fontSize: "16px",
              lineHeight: 2,
              color: "#fff",
            }}
          >
            Terms & Conditions
          </MUILink>
        </Stack>
      )}
    </Box>
  );
}
